import React, { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";

interface IProps {
  active: boolean;
  onScan: (code: string) => void;
}

const ELEMENT_ID = "stock-unit-qr-scanner";

export const QrCodeScanner: React.FC<IProps> = ({ active, onScan }) => {
  const scannerRef = useRef<Html5Qrcode | null>(null);
  const onScanRef = useRef(onScan);
  onScanRef.current = onScan;

  useEffect(() => {
    if (!active) return;

    const scanner = new Html5Qrcode(ELEMENT_ID);
    scannerRef.current = scanner;
    let stopped = false;

    scanner
      .start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 250, height: 250 } },
        (decodedText) => {
          if (!stopped) {
            onScanRef.current(decodedText);
          }
        },
        () => {}
      )
      .catch(() => {});

    return () => {
      stopped = true;
      scanner
        .stop()
        .then(() => scanner.clear())
        .catch(() => {});
    };
  }, [active]);

  return (
    <div>
      <div id={ELEMENT_ID} className="w-full max-w-md mx-auto" />
    </div>
  );
};
